'use strict';

const _ = {
    assign: require('lodash/assign'),
    filter: require('lodash/filter'),
};

var globals = {
    assignment: {
        statuses: {
            NEW: 'NEW',
            SETTING_UP: 'SETTING_UP',
            CREATING: 'CREATING',
            PENDING_READY: 'PENDING_READY',
            READYING: 'READYING',
            READY: 'READY',
            ERROR_END_TURN: 'ERROR_END_TURN',
            INTERVENTION_NEEDED: 'INTERVENTION_NEEDED',
            COMPLETE: 'COMPLETE',
            ERROR: 'ERROR',
        },
        score_types: {
            HIGHEST:'HIGHEST',
            LATEST:'LATEST',
            AVG:'AVG',
            LOWEST:'LOWEST',
        },
        types: {
            INDIVIDUAL:'INDIVIDUAL',
            MULTIPLAYER:'MULTIPLAYER',
        },
        end_turn: {
            FUTURE: 'FUTURE',
            PROCESSING: 'PROCESSING',
            COMPLETE: 'COMPLETE',
            ERROR: 'ERROR',
        },
        turn_type: {
            MANUAL: 'manual',
            INSTRUCTOR_CONTROLLED: 'controlled',
            SCHEDULED: 'scheduled',
        },
        turn_type_fiat: {
            'EXTERNAL': 'EXTERNAL',
            'OFF': 'OFF',
        },
        content_type: {
            'ACTIVITY': 'ACTIVITY',
            'MULTI_ACTIVITY': 'MULTI_ACTIVITY',
        },
        return_to: {
            'CONNECT': 'connect',
            'LAUNCH': 'launch',
            'BACK': 'back',
        }
    },
    attempt: {
        statuses:{
            NEW:'NEW',
            CREATING:'CREATING',
            READY:'READY',
            ERROR_END_TURN: 'ERROR_END_TURN',
            COMPLETE:'COMPLETE',
            ERROR:'ERROR',
            ABANDONED:'ABANDONED',
            ERROR_SENDSCORE: 'ERROR_SENDSCORE'
        },
        user_statuses: {
            NEW: 'NEW',
            STARTED: 'STARTED',
            IN_PROGRESS: 'IN_PROGRESS',
            COMPLETE: 'COMPLETE',
            ABANDONED: 'ABANDONED',
            ERROR: 'ERROR',
            ERROR_SENDSCORE: 'ERROR_SENDSCORE',
        },     
        end_turn: {
            PROCESSING: 'PROCESSING',
            COMPLETE: 'COMPLETE',
            ERROR: 'ERROR'
        }
    },
    users: {
        HASH_PREFIX: 'U-',
        HASH_PREFIX_EXT: 'XU-',
        profile: {
            SIZE_FIRST: 64,
            SIZE_LAST: 64,
            SIZE_DISPLAY: 128,
            SIZE_AFFILIATION: 64,
            SIZE_BUILD_QUESTION: 255,
        },
        roles: {
            ADMIN:'ADMIN',
            INSTRUCTOR:'INSTRUCTOR',
            STUDENT:'STUDENT',
            ASSIGNMENT_ADMIN: 'ASSIGNMENT_ADMIN',
            COURSE_INSTRUCTOR: 'COURSE_INSTRUCTOR',
            COURSE_ADMIN: 'COURSE_ADMIN',
            ORG_OWNER:'ORG_OWNER',
            ORG_ADMIN: 'ORG_ADMIN',
            ORG_SUPERVIEWER: 'ORG_SUPERVIEWER',
            ORG_VIEWER: 'ORG_VIEWER',
            ORG_PROJECT_CREATOR: 'ORG_PROJECT_CREATOR',
            ORG_MEMBER: 'ORG_MEMBER',
            ORG_GUEST: 'ORG_GUEST',
            CHANNEL_OWNER: 'CHANNEL_OWNER',
            PROJECT_MANAGER: 'PROJECT_MANAGER',
            AUTHOR: 'AUTHOR',
            REVIEWER: 'REVIEWER',
        },
        account_types: {
            EXTERNAL:'EXTERNAL',
            FREE:'FREE',
            FREE_V2:'FREE_V2',
            INDIVIDUAL:'INDIVIDUAL',
            SCHOOL:'SCHOOL',
            ENTERPRISE:'ENTERPRISE'
        },
        account_types_available: { // user accessible
            FREE_V2:'FREE_V2',
            INDIVIDUAL:'INDIVIDUAL',
            SCHOOL:'SCHOOL',
            ENTERPRISE:'ENTERPRISE'
        },
        account_features: {
            useVoiceSynthesis: 'useVoiceSynthesis', // AWS Polly
            useVoiceSynthesisMistral: 'useVoiceSynthesisMistral',
            useVoiceSynthesisElevenLabs: 'useVoiceSynthesisElevenLabs',
            useVoiceSynthesisCartesia: 'useVoiceSynthesisCartesia',
            useChatBot: 'useChatBot',
            mcgrawWebsketch: 'mcgrawWebsketch',
            mcgrawGasparVideo: 'mcgrawGasparVideo',
            shortCourseAuthoring: 'shortCourseAuthoring',
            EDLCustomExport: 'EDLCustomExport',
        },
        type: {
            LOCAL:'LOCAL',
            EXTERNAL:'EXTERNAL',
            ORG:'ORG'
        },
        local_role_type: {
            AUTHOR: 'AUTHOR',
            STUDENT: 'STUDENT',
        }
    },
    nova_credentials: {
        key: '123456',
        secret: 'abcde'
    },
    activity: {
        publish_state: {
            EDITING: 'editing',
            PUBLISHED: 'published',
            DELETED: 'deleted',
            UNPUBLISHED: 'unpublished',
        },
        edit_lock_status: {
            LOCKED: 'locked',
            UNLOCKED: 'unlocked',
            PENDING: 'pending'
        },
    },
    activity_comment: {
        type: {
            TOPIC: 'TOPIC',
            COMMENT: 'COMMENT',
            STATUS_CHANGE: 'STATUS_CHANGE',
            ASSIGNEE_CHANGE: 'ASSIGNEE_CHANGE'
        },
        status: {
            OPEN: 'OPEN',
            RESOLVED: 'RESOLVED'
        },
    },
    short_course_comment: {
        actions: {
            // note: These mirror template app action types for updating comments
            ADD_REVIEW_COMMENT: 'ADD_REVIEW_COMMENT',
            CHANGE_REVIEW_COMMENT_TEXT: 'CHANGE_REVIEW_COMMENT_TEXT',
            CHANGE_REVIEW_REPLY_TEXT: 'CHANGE_REVIEW_REPLY_TEXT',
            CHANGE_REVIEW_COMMENT_STATUS: 'CHANGE_REVIEW_COMMENT_STATUS',
            CHANGE_REVIEW_COMMENT_ASSIGNEE: 'CHANGE_REVIEW_COMMENT_ASSIGNEE',
            DELETE_REVIEW_COMMENT: 'DELETE_REVIEW_COMMENT',
        },
    },
    activity_meta_tag: {
        category: {
            KEYWORDS: 'KEYWORDS',
            TIME_ON_TASK: 'TIME_ON_TASK',
            DIFFICULTY_LEVEL: 'DIFFICULTY_LEVEL',
            BLOOMS_LEVEL: 'BLOOMS_LEVEL',
        },
        category_type: {
            FREE_FORM: 'free_form',
            ORG_CONTROLLED: 'org_controlled',
        },
    },
    activity_instance: {
        game_type: {
            DEFAULT: 'DEFAULT',
            SAMPLE: 'SAMPLE',
            PREVIEW: 'PREVIEW'
        },
    },
    group:{
        statuses: {
            // INVITED:'INVITED',   // groups don't separately handle registering user emails so the related status values are not used
            // ACCEPTED:'ACCEPTED',
            // REJECTED:'REJECTED',
            ACTIVE:'ACTIVE',
            INACTIVE:'INACTIVE',
        },
    },
    ecommerce:{
        process_types: { // aka pay_methods
            CC: 'CC',
            PO: 'PO',
            FREE: 'FREE'
        },
        subscription_statuses: {
            trialing: 'trialing',
            active: 'active',
            past_due: 'past_due',
            canceled: 'canceled',
            unpaid: 'unpaid',
            none: 'none',       // (non-stripe) if they don't have a subscription (i.e. FREE user)
            invalid: 'invalid', // (non-stripe) if there is something unexpected in the data (i.e. INDIVIDUAL with no plan)
        },
        plan_intervals: {
            month: 'month',
            year: 'year',
        },
        course_license_types: {
            INDIVIDUAL: 'individual',
            INSTITUTION: 'institution',
        },
    },
    asset: {
        STATIC_PREFIX: '$ASSET_PREFIX/'
    },
    GAPI_KEY: "AIzaSyAomOlIHvPUNE5p0qdFxGs3ELDUZcAD_ho", // Forge API key for google classroom
    GAPI_CLIENT_ID: "638927048765-7a1ri98hebote3f9cq99hc1d1crv23f8.apps.googleusercontent.com", // CLIENT_ID for google classroom
    GAPI_LoadState: {
        START: 0,
        CLIENT_LOADED: 1,
        CLIENT_INITIALIZED: 2,
    },
    integration_type: {
        LTI: 'lti', // LTI 1.1
        CONNECT: 'connect',
        LOCAL: 'mzl',
        GOOGLE_CLASSROOM: 'gc',
        LTI_1_3: 'lti_1_3', // LTI 1.3/Advantage
        VANTAGE: 'vantage',
    },
    privacy_type: {
        PUBLIC: 'public',
        PRIVATE: 'private',
    },
    site_config: {
        DEFAULT_EXAMPLE_PROJECT_NAME: 'Demo Project'
    },
    site_features: {
        'CONNECT_SEND_IN_PROGRESS': 'CONNECT_SEND_IN_PROGRESS', // TEMPORARY transitional feature flag
        'ORG_BLOCK_NON_IDP': 'ORG_BLOCK_NON_IDP', // TEMPORARY transitional feature flag
        'ACT_META_TAG_FILTERING': 'ACT_META_TAG_FILTERING',
        'ANALYTICS_COUNT_REWORK': 'ANALYTICS_COUNT_REWORK',
        'COURSE_LICENSE': 'COURSE_LICENSE',
        'DEFAULT_REG_ORG': 'DEFAULT_REG_ORG',
        'LTI_BLOCK_INVALID_ACTS': 'LTI_BLOCK_INVALID_ACTS',
    },
    sort: {
        type: {
            INT: 'int',
            STRING: 'string',
            DATE: 'date',
            CURRENCY: 'usd'
        }
    },
    view_tokens: {
        dashboard: {
            HOME: 'home',
            COURSES_STUDENT: 'courses_student',
            ASSN_STUDENT: 'assignments_student',
            ASSN_INSTRUCTOR: 'assignments_instructor',
            AUTHORING: 'authoring',
            EXPLORE: 'explore',
            HELP: 'help',
            SETTINGS: 'settings',
            GROUPS: 'groups',
        },
        author_dash: {
            CHANNEL: 'channel',
            INSTRUCTOR_ASSIGNMENTS: 'instructor_assignments',
            STUDENT_ASSIGNMENTS: 'student_assignments',
            INSTRUCTOR_COURSE_INSTS: 'instructor_courses',
            STUDENT_COURSE_INSTS: 'student_courses',
            // GROUPS: 'groups',
            channel_views: {
                FOLDER: 'folder',
                ORG_MEMBERS: 'orgMembers',
                COURSE_STATS: 'courseStats',
                STUDENT_FEEDBACK: 'studentFeedback',
                ANALYTICS: 'analytics',
                ORG_ACCOUNT_SETTINGS: 'orgAccountSettings',
                ORG_PROJECT_PERMISSIONS: 'orgProjectPermissions',
                ORG_INTEGRATION_TAGS: 'orgIntegrationTags',
                ORG_PRIVACY_POLICIES: 'orgPrivacyPolicies',
                ORG_ACT_META_TAGS: 'orgActMetaTags',
            },
            channel_subviews: {
                courseStats: {
                    COURSE: 'course',
                    SHARE: 'share',
                }
            }
        },
    },
    view_type: {
        TILE: 'tile',
        LIST: 'list'
    },
    idp_types: {
        OKTA: 'okta'
    },
    TEMP_ADMIN_CHANNEL_PERMISSIONS: { editHelp: true },
    uri: {
        query: {
            REDIRECT_TO: 'redirect',
            REDIRECT_TO_PATH: 'path',
            vantage: {
                INST_REP_STD_FILTER: 'student_3pid_filter',
                INST_REP_ATT_FILTER: 'att_num_filter',
            }
        }
    },
    qualtrics: {
        context: {
            INSTRUCTOR_DEMO: 'instructor_demo',
            STUDENT_PLAY: 'student_play',
            INSTRUCTOR_REVIEW: 'instructor_review',
            AUTHOR_PREVIEW: 'author_preview',
        },
        param: {
            CONTEXT: 'context',
            PARTNER_ID: 'partner_id',
        },
        cookie_param: {
            'ISBN': 'cookie_isbn',
            'ACT_NAME': "cookie_activity_name",
            ACTIVITY_ID: 'cookie_activity_id',
            USER_ID: 'cookie_user_id',
            TEMPLATE_NAME: 'cookie_template_name',
            PROJECT_NAME: 'cookie_project_name',
        }
    },
    maintenance: {
        'uriPath': '/authoring/maintenance',
    },
    db: {
        PSQL_INT_MAX: 2147483647,
    },
    analytics: {
        SAMPLE_LINK_ASSN_HASH_PREFIX: 'SAMPLE',
        question_type: {
            MCQ: "MCQ",
            FIBQ: "FIBQ",
            ATAQ: "ATAQ",
            CATQ: "CATQ",
            LIKERT: "LIKERT",
            RANKED: "RANKED",
            MATCH: "MATCH",
        },
        question_quality: {
            FACT: "fact",
            OPINION: "opinion",
        },
        multi_act: {
            MULTI_ACT_OVERALL_ATT_KEY: "overall",
        },
    },
    sso: {
        response_types: {
            CODE: 'code',
        },
        scopes: {
            OPEN_ID: 'openid',
            EMAIL: 'email',
            PROFILE: 'profile',
        },
        grant_types: {
            AUTHORIZATION_CODE: 'authorization_code',
            PASSWORD: 'password',
            CLIENT_CREDENTIALS: 'client_credentials',
            REFRESH_TOKEN: 'refresh_token',
        },
        errors: { // https://datatracker.ietf.org/doc/html/rfc6749#section-5.2, https://openid.net/specs/openid-connect-core-1_0.html#AuthError
            INVALID_REQUEST: 'invalid_request',
            INVALID_CLIENT: 'invalid_client',
            INVALID_GRANT: 'invalid_grant',
            INVALID_SCOPE: 'invalid_scope',
            UNAUTHORIZED_CLIENT: 'unauthorized_client',
            ACCESS_DENIED: 'access_denied',
            UNSUPPORTED_RESPONSE_TYPE: 'unsupported_response_type',
            UNSUPPORTED_GRANT_TYPE: 'unsupported_grant_type',
            REQUEST_NOT_SUPPORTED: 'request_not_supported',
            REQUEST_URI_NOT_SUPPORTED: 'request_uri_not_supported',
            REGISTRATION_NOT_SUPPORTED: 'registration_not_supported',
            SERVER_ERROR: 'server_error',
            TEMPORARILY_UNAVAILABLE: 'temporarily_unavailable',
        },

    },
    content_type: {
        ACTIVITY: "activity",
        COURSE: "course",
        ASSIGNMENT: "assignment",
    },
    short_course: {
        node_type: {
            V1: "v1",
        },
        node_content_credit_type: {
            ASSESSMENT: "assessment",
            PRACTICE: "practice",
            TUTORIAL: "tutorial",
        },
        node_content_order : {
            FIRST: 'first',
            NORMAL: 'normal',
            FINAL: 'final',
        },
        content_block_type: {
            ACTIVITY: "activity",
            LINK: "link",
            CHATBOT: "chatbot",
        },
        content_block_link_type: {
            PDF: "pdf",
            VIDEO: "video",
        },
        content_block_score_req_type: {
            OVERALL: 'overall',
            OBJECTIVE: 'objective'
        },
		content_block_activity_types: {
			KNOWLEDGE_CHECK:  	'Knowledge Check', 	
			PRE_TEST:  			'Pre-Test', 		
			FINAL:  			'Final', 			
			REMEDIAL_1:  		'Remedial Level 1', 
			REMEDIAL_2:  		'Remedial Level 2',
            TUTORIAL:           'Tutorial',
		},
		REMEDIAL_ACTIVITY_TYPES: ['REMEDIAL_1','REMEDIAL_2'],
		ASSESSMENT_ACTIVITY_TYPES: ['KNOWLEDGE_CHECK','PRE_TEST','FINAL'],
        TUTORIAL_ACTIVITY_TYPES: ['TUTORIAL'],
		
    },
    short_course_instance: {
        ADD_USER_LIMIT: 1000,
        param_options: {
            REQUIRED: 'required',
            OPTIONAL: 'optional',
            HIDE: 'hide',
        },
    },
    BADGE_SERVICE_TYPES: { // these should match psql e_badge_service_type enum
        credly: "credly",
        accredible: "accredible",
    },
    BADGE_SERVICE_TRAITS: {}, // these will be filled out below...
    RSD_SERVICE_TYPES: { // these should match psql e_rsd_service_type enum
        OpenRSD: "OpenRSD",
        MZL: "MZL",
    },
    date: {
        SERVICE_DATE_MIN_YYYY_MM_DD: "2015-01-01", // a rough global date minimum reflect prod service inception
    },
    user_actions: {
        version: { // format/schema of a specific action
            V1: "V1",
        },
        type: {
            ACTIVITY_CREATE: "ACTIVITY_CREATE",
            ACTIVITY_EDIT: "ACTIVITY_EDIT",
            ACTIVITY_SAVE: "ACTIVITY_SAVE",
            ACTIVITY_RENAME: "ACTIVITY_RENAME",
            ACTIVITY_PUBLISH: "ACTIVITY_PUBLISH",
            ACTIVITY_UNPUBLISH: "ACTIVITY_UNPUBLISH",
            ACTIVITY_DELETE: "ACTIVITY_DELETE",
            ACTIVITY_MOVE: "ACTIVITY_MOVE",
            ACTIVITY_COPY: "ACTIVITY_COPY",
            ACTIVITY_ATTACH_I_TAG: "ACTIVITY_ATTACH_I_TAG",
            ACTIVITY_REMOVE_I_TAG: "ACTIVITY_REMOVE_I_TAG",
            ACTIVITY_ATTACH_M_TAG: "ACTIVITY_ATTACH_M_TAG",
            ACTIVITY_REMOVE_M_TAG: "ACTIVITY_REMOVE_M_TAG",
            ACTIVITY_CREATE_LOCAL_ASSN: "ACTIVITY_CREATE_LOCAL_ASSN",
            ACTIVITY_UPDATE_DISPLAY_NAME: "ACTIVITY_UPDATE_DISPLAY_NAME",
            ACTIVITY_UPDATE_IMAGE: "ACTIVITY_UPDATE_IMAGE",
            ACTIVITY_UPDATE_DESCRIPTION: "ACTIVITY_UPDATE_DESCRIPTION",
            ACTIVITY_UPDATE_COURSE_METADATA: "ACTIVITY_UPDATE_COURSE_METADATA",
            PROJECT_CREATE: "PROJECT_CREATE",
            PROJECT_ADD_COLLAB: "PROJECT_ADD_COLLAB",
            PROJECT_EDIT_COLLAB: "PROJECT_EDIT_COLLAB",
            PROJECT_REMOVE_COLLAB: "PROJECT_REMOVE_COLLAB",
            PROJECT_RENAME: "PROJECT_RENAME",
            PROJECT_COPY: "PROJECT_COPY",
            PROJECT_MOVE: "PROJECT_MOVE",
            PROJECT_DELETE: "PROJECT_DELETE",
            PROJECT_ATTACH_I_TAG: "PROJECT_ATTACH_I_TAG",
            PROJECT_REMOVE_I_TAG: "PROJECT_REMOVE_I_TAG",
            PROJECT_ADDED_AS_COLLABORATOR: "PROJECT_ADDED_AS_COLLABORATOR",
            PROJECT_REMOVED_AS_COLLABORATOR: "PROJECT_REMOVED_AS_COLLABORATOR",
            PROJECT_ROLE_CHANGED: "PROJECT_ROLE_CHANGED",
            CHANNEL_FOLDER_CREATE: "CHANNEL_FOLDER_CREATE",
            CHANNEL_EXPORT_I_TAGS: "CHANNEL_EXPORT_I_TAGS",
            CHANNEL_IMPORT_I_TAGS: "CHANNEL_IMPORT_I_TAGS",
            CHANNEL_ADD_I_TAG: "CHANNEL_ADD_I_TAG",
            CHANNEL_DELETE_I_TAG: "CHANNEL_DELETE_I_TAG",
            CHANNEL_EDIT_I_TAG: "CHANNEL_EDIT_I_TAG",
            CHANNEL_EXPORT_M_TAGS: "CHANNEL_EXPORT_M_TAGS",
            CHANNEL_IMPORT_M_TAGS: "CHANNEL_IMPORT_M_TAGS",
            CHANNEL_ADD_M_TAG: "CHANNEL_ADD_M_TAG",
            CHANNEL_DELETE_M_TAG: "CHANNEL_DELETE_M_TAG",
            CHANNEL_EDIT_M_TAG: "CHANNEL_EDIT_M_TAG",
            CHANNEL_ADD_PP_TAG: "CHANNEL_ADD_PP_TAG",
            CHANNEL_DELETE_PP_TAG: "CHANNEL_DELETE_PP_TAG",
            CHANNEL_EDIT_PP_TAG: "CHANNEL_EDIT_PP_TAG",
            ORG_ADDED_TO: "ORG_ADDED_TO",
            ORG_REMOVED_FROM: "ORG_REMOVED_FROM",
            ORG_ROLE_CHANGED: "ORG_ROLE_CHANGED",
            ORG_EDIT_LMS_DEPLOYMENT: "ORG_EDIT_LMS_DEPLOYMENT",
            ADMIN_EDIT_LMS_DEPLOYMENT: "ADMIN_EDIT_LMS_DEPLOYMENT",
            ADMIN_ADD_LMS_DEPLOYMENT: "ADMIN_ADD_LMS_DEPLOYMENT",
            ADMIN_ARCHIVE_LMS_DEPLOYMENT: "ADMIN_ARCHIVE_LMS_DEPLOYMENT",
            ADMIN_UNARCHIVE_LMS_DEPLOYMENT: "ADMIN_UNARCHIVE_LMS_DEPLOYMENT",
            ACCOUNT_EDIT_DISP_NAME: "ACCOUNT_EDIT_DISP_NAME",
            ACCOUNT_EDIT_PASSWORD: "ACCOUNT_EDIT_PASSWORD",
            ACCOUNT_EDIT_EMAIL: "ACCOUNT_EDIT_EMAIL",
            ACCOUNT_EDIT_SHARE_POLICY: "ACCOUNT_EDIT_SHARE_POLICY",
            ACCOUNT_ADD_BADGE_SERVICE: "ACCOUNT_ADD_BADGE_SERVICE",
            ACCOUNT_EDIT_BADGE_SERVICE: "ACCOUNT_EDIT_BADGE_SERVICE",
            ACCOUNT_ADD_BADGE_TEMPLATE: "ACCOUNT_ADD_BADGE_TEMPLATE",
            ACCOUNT_ADD_SKILL_SERVICE: "ACCOUNT_ADD_SKILL_SERVICE",
            ACCOUNT_EDIT_SKILL_SERVICE: "ACCOUNT_EDIT_SKILL_SERVICE",
            ASSN_CREATE: "ASSN_CREATE",
            ASSN_EDIT_DATES: "ASSN_EDIT_DATES",
            ASSN_EDIT_SCORE_TYPE: "ASSN_EDIT_SCORE_TYPE",
            ASSN_EDIT_NUM_ATT: "ASSN_EDIT_NUM_ATT",
            ASSN_START_ATTEMPT: "ASSN_START_ATTEMPT",
            ASSN_COMPLETE_ATTEMPT: "ASSN_COMPLETE_ATTEMPT",
            COURSE_CREATE: "COURSE_CREATE",
            COURSE_EDIT: "COURSE_EDIT",
            COURSE_SAVE: "COURSE_SAVE",
            COURSE_PUBLISH: "COURSE_PUBLISH",
            COURSE_UNPUBLISH: "COURSE_UNPUBLISH",
            COURSE_RENAME: "COURSE_RENAME",
            COURSE_DELETE: "COURSE_DELETE",
            COURSE_COPY: "COURSE_COPY",
            COURSE_MOVE: "COURSE_MOVE",
            COURSE_INST_CREATE_LOCAL: "COURSE_INST_CREATE_LOCAL",
            COURSE_INST_START_ATTEMPT: "COURSE_INST_START_ATTEMPT",
            COURSE_INST_PROGRESS_ATTEMPT: "COURSE_INST_PROGRESS_ATTEMPT",
            COURSE_INST_COMPLETE_ATTEMPT: "COURSE_INST_COMPLETE_ATTEMPT",
            GROUP_CREATE: "GROUP_CREATE",
            GROUP_RENAME: "GROUP_RENAME",
            GROUP_ADD_USER: "GROUP_ADD_USER",
            GROUP_REMOVE_USER: "GROUP_REMOVE_USER",
            USER_LOGIN: "USER_LOGIN",
        },
        // for retrieving history
        day_ranges: {
            LAST_7_DAYS: "7",
            LAST_30_DAYS: "30",
            LAST_60_DAYS: "60",
            LAST_90_DAYS: "90",
            ALL: "all",
        }
    },
    cookie_names: {
        OIDC_STATE: 'oidc_state', // changed to fix conflict with old 'state' cookie before adding partitioned
    },
    ai: {
        useCases: {
            OPEN_RESPONSE: 'OPEN_RESPONSE',
            GENERATE_CONTENT: 'GENERATE_CONTENT',
            AI_TUTOR: 'AI_TUTOR',
            BG_IMAGE: 'BG_IMAGE',
            MATERIAL_IMAGE: 'MATERIAL_IMAGE',
        },
        useCaseModelParams: {
            OPEN_RESPONSE: { temperature: 0.1 },
            GENERATE_CONTENT: { temperature: 0.7 },
            AI_TUTOR: { temperature: 0.5 },
            BG_IMAGE: { width: 2720, height: 1520, quality: "standard"},
            MATERIAL_IMAGE: { width: 1024, height: 816, quality: "standard"},
        },
    },
    // related to voice and chat permissions 
    SYSTEM_USAGE: {
        ASSIGNMENT: "ASSIGNMENT",
        ACTIVITY_EDIT: "ACTIVITY_EDIT",
        ACTIVITY_PREVIEW: "ACTIVITY_PREVIEW",
        SHORT_COURSE_PLAY: "SHORT_COURSE_PLAY",
        SHARE_LINK: "SHARE_LINK", // not logged in
    },
    
    CHART_COLORS: ["#1f77b4","#EB6D00","#2ca02c","#d62728","#9467bd","#8c564b","#E067BB","#7f7f7f","#98981B","#14A3B3"], // all > 3:1 contrast with white
    
    VOICE_SYSTEMS: {
        POLLY: "POLLY",
        ELEVENLABS: "ELEVENLABS",
        CARTESIA: "CARTESIA",
    },
    ELEVENLABS_ENGINES: ["eleven_v3", "eleven_flash_v2_5"],
    CARTESIA_ENGINES: ["sonic-3.5"],
    // ElevenLabs and Cartesia always stream with these models, whichever engine was requested (see canStreamAndSave)
    STREAMING_ELEVENLABS_MODEL_ID: "eleven_flash_v2_5",
    STREAMING_CARTESIA_MODEL_ID: "sonic-3.5",
};

// helper functions that need to refer to values within globals itself

var _account_type_types = {}; // 'type' is overused ...
_account_type_types[globals.users.account_types.EXTERNAL]      = globals.users.type.EXTERNAL;
_account_type_types[globals.users.account_types.FREE]          = globals.users.type.LOCAL;
_account_type_types[globals.users.account_types.FREE_V2]       = globals.users.type.LOCAL;
_account_type_types[globals.users.account_types.INDIVIDUAL]    = globals.users.type.LOCAL;
_account_type_types[globals.users.account_types.SCHOOL]        = globals.users.type.ORG;
_account_type_types[globals.users.account_types.ENTERPRISE]    = globals.users.type.ORG;

_.assign(globals.users,{
    get_org_account_types: function() {
        return _.filter(globals.users.account_types,function(val) { return _account_type_types[val] === globals.users.type.ORG; });
    },

    get_user_account_types: function() {
        return _.filter(globals.users.account_types,function(val) { return _account_type_types[val] !== globals.users.type.ORG; });
    },

    is_org_account_type: function(account_type) {
        return _account_type_types[account_type] === globals.users.type.ORG;
    },

    is_user_account_type: function(account_type) {
        return _account_type_types[account_type] !== globals.users.type.ORG;
    }
});

// whether a streamed phrase can be saved as the cached audio for this engine (stream&save).
// ElevenLabs and Cartesia stream with their streaming model, so only that engine's stream has the quality we cache.  Polly streams with the requested engine
globals.canStreamAndSave = function(engine) {
    if ((engine === 'elevenlabs') || globals.ELEVENLABS_ENGINES.includes(engine)) { // 'elevenlabs' is the old engine option
        return engine === globals.STREAMING_ELEVENLABS_MODEL_ID;
    }
    if (globals.CARTESIA_ENGINES.includes(engine)) {
        return engine === globals.STREAMING_CARTESIA_MODEL_ID;
    }
    return true; // Polly
};

globals.BADGE_SERVICE_TRAITS[globals.BADGE_SERVICE_TYPES.accredible]={
    missing_img_url: true, // true if the data for badge templates on this service don't provide an image url
};


module.exports = globals;
